import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink, Typography } from '@mui/material';
import LegalLayout from './LegalLayout';

function ConditionsPage() {
  return (
    <LegalLayout title="Conditions d'utilisation">
      <Typography variant="body2" sx={{ color: '#888', mb: 2 }}>
        Dernière mise à jour : octobre 2026
      </Typography>

      <p>
        Les présentes conditions régissent l&apos;utilisation de <strong>baoubab</strong>,
        plateforme éducative éditée par <strong>Bokonzi</strong> (Abidjan), accessible via
        l&apos;application mobile et le site{' '}
        <MuiLink href="https://baoubab.space">baoubab.space</MuiLink>.
      </p>

      <h2>1. Objet du service</h2>
      <p>
        baoubab propose des outils d&apos;accompagnement pédagogique pour les parents et
        enseignants : création de profils enfants, questionnaires de profilage,
        recommandations d&apos;activités et contenus associés. Le parcours
        « neuroatypique » fournit une orientation pédagogique ;{' '}
        <strong>il ne constitue en aucun cas un diagnostic médical</strong>.
      </p>

      <h2>2. Compte utilisateur</h2>
      <ul>
        <li>L&apos;accès se fait par adresse e-mail et code OTP à usage limité.</li>
        <li>Vous êtes responsable de la confidentialité de votre boîte e-mail.</li>
        <li>
          Les informations relatives aux enfants doivent être fournies par un parent ou
          tuteur légal, ou un enseignant autorisé dans le cadre de son activité.
        </li>
      </ul>

      <h2>3. Utilisation acceptable</h2>
      <p>Il est interdit d&apos;utiliser le service pour :</p>
      <ul>
        <li>usurper l&apos;identité d&apos;autrui ;</li>
        <li>collecter des données d&apos;enfants sans droit légitime ;</li>
        <li>perturber le fonctionnement de la plateforme ;</li>
        <li>présenter les résultats baoubab comme un diagnostic médical.</li>
      </ul>

      <h2>4. Contenu et propriété intellectuelle</h2>
      <p>
        Les contenus, marques et éléments graphiques de baoubab restent la propriété de
        Bokonzi ou de ses partenaires. Toute reproduction non autorisée est interdite.
      </p>

      <h2>5. Commandes et paiements</h2>
      <p>
        Certaines activités ou produits peuvent être commandés via l&apos;application.
        Les modalités (disponibilité, livraison, annulation) sont précisées au moment de
        la commande. Les litiges commerciaux peuvent être adressés à{' '}
        <MuiLink href="mailto:bokonzibaoubab@gmail.com">bokonzibaoubab@gmail.com</MuiLink>.
      </p>

      <h2>6. Limitation de responsabilité</h2>
      <p>
        baoubab fournit des informations et recommandations à caractère pédagogique.
        Bokonzi ne saurait être tenu responsable d&apos;une utilisation des résultats
        comme substitut à un avis médical, psychologique ou scolaire professionnel.
      </p>

      <h2>7. Suspension et résiliation</h2>
      <p>
        Nous pouvons suspendre un compte en cas de manquement aux présentes conditions.
        Vous pouvez demander la suppression de votre compte à tout moment via{' '}
        <MuiLink component={RouterLink} to="/suppression-compte">cette page</MuiLink>.
      </p>

      <h2>8. Données personnelles</h2>
      <p>
        Le traitement des données est décrit dans la{' '}
        <MuiLink component={RouterLink} to="/confidentialite">
          politique de confidentialité
        </MuiLink>.
      </p>

      <h2>9. Contact</h2>
      <p>
        Pour toute question :{' '}
        <MuiLink component={RouterLink} to="/contact">formulaire de contact</MuiLink>
        {' '}ou{' '}
        <MuiLink href="mailto:bokonzibaoubab@gmail.com">bokonzibaoubab@gmail.com</MuiLink>.
      </p>
    </LegalLayout>
  );
}

export default ConditionsPage;
